import { useEffect, useState } from "react";
import { useOasisBackend } from "../../hooks/useOasisBackend";
import { toast, ToastContainer } from "react-toastify";
import { SemanticIndexRequest, OasisIndexRequest } from "../../api/OasisBackendApi";

const IndexRequestManager = ({databaseId, entityCollectionId}: {databaseId: string, entityCollectionId: string}) => {
    const db = useOasisBackend();

    const [semanticIndexRequests, setSemanticIndexRequests] = useState<SemanticIndexRequest[]>([]);
    const [oasisIndexRequests, setOasisIndexRequests] = useState<OasisIndexRequest[]>([]);

    const indexEntities = async (index_type: string) => {
        const response = await db.endpoints.api.apiDatabaseIndexEntityCollectionCreate(databaseId, {index_type: index_type as "semantic" | "oasis"});
        console.log("Index Request Response", response);
        if (response.status === 201) {
            toast.success("Entities indexing processing");
            // Start polling immediately after initiating a new request
            fetchIndexRequests();
        } else {
            toast.error("Failed to index entities");
        }
    }

    const fetchIndexRequests = async () => {
        console.log("Fetching Index Requests");
        const response = await db.endpoints.api.apiEntityCollectionIndexRequestsRetrieve(entityCollectionId);
        console.log(response);
        setSemanticIndexRequests(response.data.semantic_index_requests);
        setOasisIndexRequests(response.data.oasis_index_requests);
    }
    
    // Check if there are any requests not at failed or completed
    const hasActiveRequests = () => {
        const allRequests = [...semanticIndexRequests, ...oasisIndexRequests];
        return allRequests.some(request =>
            request.status !== "failed" && request.status !== "completed"
        );
    };

    useEffect(() => {
        fetchIndexRequests();
    }, []);

    useEffect(() => {
        if (!hasActiveRequests()) return;

        const pollInterval = setInterval(() => {
            fetchIndexRequests();
        }, 2000); // Poll every 2 seconds

        return () => clearInterval(pollInterval);
    }, [semanticIndexRequests, oasisIndexRequests]);

    return(
        <div>
            <ToastContainer />
            <button onClick={() => indexEntities("semantic")}>Index Semantic</button>
            <button onClick={() => indexEntities("oasis")}>Index Oasis</button>
            <div>
                <h2>Semantic Index Requests</h2>
                <ul>
                    {semanticIndexRequests && semanticIndexRequests.map((request) => (
                        <li key={request.id}>{request.id} - {request.status}</li>
                    ))}
                </ul>
            </div>
            <div>
                <h2>Oasis Index Requests</h2>
                <ul>
                    {oasisIndexRequests && oasisIndexRequests.map((request) => (
                        <li key={request.id}>{request.id} - {request.status}</li>
                    ))}
                </ul>
            </div>
        </div>

    )
}

export default IndexRequestManager;